/**
 * Notification list component to display individual notification items
 * Following presentation component pattern
 */
import type { NotificationResponseDto } from '@splitfiesta/shared';

import NotificationItem from './NotificationItem';

interface NotificationListProps {
  notifications: NotificationResponseDto[];
  showGroupName?: boolean;
  compact?: boolean; // When true, items have no padding (for use in pages with custom layout)
}

/**
 * Presentation component for rendering list of notifications
 */
export default function NotificationList({
  notifications,
  showGroupName = false,
  compact = false,
}: NotificationListProps) {
  return (
    <div className="divide-y divide-gray-200 dark:divide-gray-700">
      {notifications.map((notification, index) => (
        <NotificationItem
          key={notification.id || `notification-${index}`}
          notification={notification}
          showGroupName={showGroupName}
          compact={compact}
        />
      ))}
    </div>
  );
}
